/**
 * The address of the last sign-in on this device, so a person who comes back
 * (the session was lost, or they were signed out) finds /login ready for them
 * (session audit R5).
 *
 * Only the email, never a token or a password; localStorage, not a cookie, so
 * it is never sent to the server. Every access is wrapped: private windows and
 * blocked storage throw, and the screen must work without it.
 */
const KEY = 'alumnia.lastLoginEmail'

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function readRememberedEmail(): string | null {
  try {
    const value = window.localStorage.getItem(KEY)?.trim().toLowerCase()
    return value && value.length <= 254 && EMAIL_PATTERN.test(value) ? value : null
  } catch {
    return null
  }
}

export function rememberEmail(email: string): void {
  try {
    const value = email.trim().toLowerCase()
    if (value.length <= 254 && EMAIL_PATTERN.test(value)) window.localStorage.setItem(KEY, value)
  } catch {
    // Storage blocked: nothing to remember with.
  }
}

/** "Usar otra cuenta". */
export function forgetRememberedEmail(): void {
  try {
    window.localStorage.removeItem(KEY)
  } catch {
    // Nothing to clear.
  }
}
